// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMeta from 'vue-meta'
import VuePageTransition from 'vue-page-transition'
// import vuescroll from 'vuescroll'
import vuescroll from 'vuescroll/dist/vuescroll-native'
import Vue2TouchEvents from 'vue2-touch-events'
import PortalVue from 'portal-vue'

import App from './App'
import router from './router'
import store from './store'

require('tippy.js/dist/tippy.css')
require('tippy.js/animations/shift-away.css')
require('tippy.js/themes/light-border.css')

Vue.use(PortalVue)
Vue.use(VuePageTransition)
Vue.use(vuescroll)
Vue.use(Vue2TouchEvents)

// https://github.com/nuxt/vue-meta
Vue.use(VueMeta, {
	refreshOnceOnNavigation: true
})

require('./styles/bulma.scss')
require('./styles/global.styl')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el        : '#app',
	store,
	router,
	components: { App },
	template  : '<App/>'
})
